"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * An {@link AssignmentCache} implementation that, upon `init`, reads from a persistent and async {@link BulkReadAssignmentCache}
 * and writes to a synchronous {@link BulkWriteAssignmentCache} for serving the cache.
 * */
class HybridAssignmentCache {
    constructor(servingStore, persistentStore) {
        this.servingStore = servingStore;
        this.persistentStore = persistentStore;
    }
    async init() {
        const entries = await this.persistentStore.getEntries();
        if (entries) {
            this.servingStore.setEntries(entries);
        }
    }
    set(key) {
        this.servingStore.set(key);
        this.persistentStore.set(key);
    }
    has(key) {
        return this.servingStore.has(key);
    }
}
exports.default = HybridAssignmentCache;
//# sourceMappingURL=hybrid-assignment-cache.js.map